<template>
  <div class="box">
    <div id="app-home">
      <div class="header"></div>
      <!-- title="可赠送"  -->
      <div style="padding-top: 20px" v-if="typeFlag == '1'">
        <div class="goback">
          <div @click="goback">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
        </div>
        <div class="message">
          <div class="t1">亲爱的{{ $store.state.userInfo.nickname }}：</div>
          <div class="c1">
            你的每一次点赞，都让一颗星星被看见。请点亮你身边的星光，让荧荧星光汇聚成照亮彼此的星河，让每一份认真都不被辜负，让每一个努力的背影都有人记得。
          </div>
        </div>
        <div class="last">
          <div class="tab-con1" v-if="list.length > 0">
            <div class="topCon" v-for="item in list" :key="item.id">
              <img src="@/assets/medal/quaquaka/background2.png" alt="" />
              <div class="topTit">点赞卡x1</div>
              <div class="topDate">有效期至：{{ item.endTime }}</div>
              <div class="num">{{ item.point ? item.point : "10" }}分</div>
              <div class="btnCon">
                <van-button
                  class="btnOne"
                  type="default"
                  v-if="item.status == '1'"
                  @click.stop="onClickSong(item.id)"
                  >点赞</van-button
                >
                <van-button class="btnTwo" v-if="item.status == '2'"
                  >已点赞</van-button
                >
              </div>
            </div>
          </div>
          <div class="kong_con" v-else>
            <img class="kong_img" src="@/assets/newsNotice/kong.png" alt="" />
            <div
              class="kong_title kong_title1"
              v-if="$store.state.userInfo.rtitle == 'O1'"
            >
              您暂无赠送点赞卡权限
            </div>
            <div class="kong_title kong_title1" v-else>
              您本月赠送次数已用完
            </div>
            <!-- <div class="kong_title">请加油吧～</div> -->
          </div>
        </div>
      </div>
      <!-- title="我赠送的" -->
      <div style="padding-top: 20px" v-if="typeFlag == '2'">
        <div class="goback">
          <div @click="goback">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
          <div class="goback_search">
            <el-input
              v-model="searchValue"
              placeholder="请输入..."
              @input="changeSearchValue1"
            ></el-input>
            <i class="el-icon-search"></i>
          </div>
        </div>
        <div class="message">
          <div class="c1">
            夸奖和认可是激励的最佳方式。请主动赞扬那些在工作中表现出色的同事，让他们知道他们的努力受到重视。你的一句真诚夸奖，将为团队注入更多积极能量和合作精神。让我们一起打造一个充满支持和鼓励的工作环境！
          </div>
        </div>
        <div class="pick">
          <div class="newDate" @click="showPickDate = true">
            {{ newDate }}
          </div>
          <i class="el-icon-date"></i>
          <van-popup v-model="showPickDate" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              type="year-month"
              title="选择年月"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="comfirmPickTime"
              @cancel="showPickDate = false"
            />
          </van-popup>
        </div>
        <div class="last">
          <div class="tab-con1" v-if="listTwo.length > 0">
            <div class="topCon" v-for="item in listTwo" :key="item.id">
              <img src="@/assets/medal/quaquaka/background3.png" alt="" />
              <div class="topTit" v-if="item.cardType == 1">
                送给{{ item.receivername }}的点赞卡
              </div>
              <div class="topTit" v-if="item.cardType == 3">
                系统赠送的周年卡
              </div>
              <div class="topTit" v-if="item.cardType == 2">
                集团奖励的勋章卡
              </div>
              <div class="topTit" v-if="item.cardType == 4">
                集团奖励的公益卡
              </div>
              <div class="topDate">
                {{ item.createDateFormat }}
              </div>
              <div class="btnCon">
                <van-button class="btnOne" @click="toUrl1(item)"
                  >立即打开</van-button
                >
              </div>
            </div>
          </div>
          <div class="kong_con" v-else>
            <img class="kong_img" src="@/assets/newsNotice/kong.png" alt="" />
            <div class="kong_title kong_title1">您还未送出点赞卡</div>
            <!-- <div class="kong_title">请加油吧～</div> -->
          </div>
        </div>
      </div>
      <!-- title="我收到的" -->
      <div style="padding-top: 20px" v-if="typeFlag == '3'">
        <div class="goback">
          <div @click="goback">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
          <div class="goback_search">
            <el-input
              v-model="searchValue2"
              placeholder="请输入..."
              @input="changeSearchValue2"
            ></el-input>
            <i class="el-icon-search"></i>
          </div>
        </div>
        <div class="message">
          <div class="c1">
            夸奖和认可是激励的最佳方式。请主动赞扬那些在工作中表现出色的同事，让他们知道他们的努力受到重视。你的一句真诚夸奖，将为团队注入更多积极能量和合作精神。让我们一起打造一个充满支持和鼓励的工作环境！
          </div>
        </div>
        <div class="pick">
          <div class="newDate" @click="showPickDate2 = true">
            {{ newDate2 }}
          </div>
          <i class="el-icon-date"></i>
          <van-popup v-model="showPickDate2" position="bottom">
            <van-datetime-picker
              v-model="currentDate2"
              type="year-month"
              title="选择年月"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="comfirmPickTime2"
              @cancel="showPickDate2 = false"
            />
          </van-popup>
        </div>
        <div class="last" style="margin-top: 20px">
          <div class="tab-con1" v-if="listThree.length > 0">
            <div class="topCon" v-for="item in listThree" :key="item.id">
              <img src="@/assets/medal/quaquaka/background4.png" alt="" />
              <div class="topTit" v-if="item.cardType == 1">
                {{ item.sendername }}的点赞卡
              </div>
              <div class="topTit" v-if="item.cardType == 3">
                系统赠送的周年卡
              </div>
              <div class="topTit" v-if="item.cardType == 2">
                集团奖励的勋章卡
              </div>
              <div class="topTit" v-if="item.cardType == 4">
                集团奖励的公益卡
              </div>
              <div class="topDate">
                {{ item.createDateFormat }}
              </div>
              <div class="btnCon">
                <van-button class="btnOne" @click="toUrl(item)"
                  >立即打开</van-button
                >
              </div>
            </div>
          </div>
          <div class="kong_con" v-else>
            <img class="kong_img" src="@/assets/newsNotice/kong.png" alt="" />
            <div class="kong_title kong_title1">您还没有获得任何勋章</div>
            <div class="kong_title">请加油吧～</div>
          </div>
        </div>
      </div>
      <!-- 进入页面时展示点赞卡使用说明 -->
      <van-dialog
        class="usage-guide-dialog"
        v-model="showUsageGuide"
        :show-confirm-button="false"
        :close-on-click-overlay="false"
        z-index="2000"
      >
        <div class="usage-guide">
          <div class="usage-guide-title">点赞卡使用说明</div>
          <div class="usage-guide-content">
            <div class="usage-guide-section">
              <strong>一、使用规则：</strong>
              <p>
                1. 优秀不止一种打开方式，请多场景、多维度去发现身边同事的高光时刻，还有更多宝藏同事值得被看见。
              </p>
              <p>2. 系统每月自动发卡，当月有效，记得及时点赞哦。</p>
              <p>
                3. 获得积分每周一自动同步福利商城，可在商城兑换实物商品。积分有效期至次年1月31日，到期自动失效，别让积分悄悄溜走。
              </p>
            </div>
            <div class="usage-guide-section">
              <strong>二、温馨提示：</strong>
              <p>
                1. 拒绝弄虚作假、约定点赞等不当操作，系统会监控异常行为并开展核查。请尊重每一份真心，让认可回归认可。
              </p>
              <p>
                2. 公司将依规处理违规者，包括但不限于：口头提醒、收回积分、关闭系统权限、取消当年评优资格、通报批评等，详见《荣誉体系管理制度》。
              </p>
            </div>
          </div>
          <van-button
            class="usage-guide-button"
            type="primary"
            block
            @click="handleKnowGuide"
          >
            我知道了
          </van-button>
        </div>
      </van-dialog>
      <van-dialog
        class="dialog"
        v-model="showTip"
        :showConfirmButton="false"
        z-index="1999"
      >
        <div class="dialog-people">
          赠与人：<el-select
            v-model="value"
            placeholder="请输入赠送名字"
            clearable
            filterable
            remote
            :remote-method="changeOption"
            :loading="loadingSelect"
            ref="select"
            @blur.native.capture="onblur"
            @hook:mounted="cancalReadOnly"
            @visible-change="cancalReadOnly"
          >
            <el-option
              v-for="item in options"
              :key="item.empid"
              :label="item.orgname + '-' + item.name"
              :value="item.empid"
            >
            </el-option>
          </el-select>
        </div>
        <div class="dialog-people cc">
          抄送人：<el-select
            v-model="valueCC"
            placeholder="请选择抄送人"
            multiple
            filterable
            remote
            :remote-method="changeOption"
            :loading="loadingSelect"
            ref="select2"
            @blur.native.capture="onblur2"
            @hook:mounted="cancalReadOnly2"
            @visible-change="cancalReadOnly2"
          >
            <el-option
              v-for="item in options"
              :key="item.empid"
              :label="item.orgname + '-' + item.name"
              :value="item.empid"
            >
            </el-option>
          </el-select>
        </div>
        <div class="dialog-reason">
          夸夸理由：
          <div>
            <van-field
              v-model="message"
              rows="2"
              autosize
              type="textarea"
              maxlength="200"
              placeholder="请输入感谢理由，内容仅限200字以内。"
              show-word-limit
            />
          </div>
        </div>
        <div class="dialog-btn">
          <el-button @click="handelNo">取消</el-button>
          <el-button
            @click="handelOk"
            style="background: rgba(72, 158, 108, 1); color: #fff"
            :disabled="disabled"
            >发送</el-button
          >
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import api from "@/apis/medal";
import moment from "moment";
import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";
// import apis from "@/apis";
export default {
  name: "quaquaka",
  components: {},
  data() {
    return {
      active: "",
      list: [],
      listTwo: [],
      listThree: [],
      listFour: [],
      list1: [],
      listTwo1: [],
      listThree1: [],
      listFour1: [],
      loadingOne: false,
      loadingTwo: false,
      loadingThree: false,
      loadingFour: false,
      finishedOne: false,
      finishedTwo: false,
      finishedThree: false,
      finishedFour: false,
      disabled: false,
      options: [],
      totalAllOne: 0,
      totalAllTwo: 0,
      totalAllThree: 0,
      totalAllFour: 0,
      totalAllOne1: 0,
      totalAllTwo1: 0,
      totalAllThree1: 0,
      totalAllFour1: 0,
      value: "", // 赠送人
      valueCC: [], // 抄送人
      message: "",
      loadingSelect: false,
      showTip: false,
      showUsageGuide: false, // 初始改为false，mounted里判断
      icon: require("@/assets/medal/quaquaka/icon.png"),
      pageOne: 1,
      pageTwo: 1,
      pageThree: 1,
      pageFour: 1,
      id: "",
      activeTabs: 1,
      empno: "",
      pageSize: 20,
      showUserBadge: true,
      searchValue: "",
      searchValue2: "",
      typeFlag: "",
      showPickDate: false,
      showPickDate2: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      newDate: moment().format("YYYY-MM"),
      newDateValue: moment().format("YYYY-MM"),
      currentDate2: new Date(),
      newDate2: moment().format("YYYY-MM"),
      newDateValue2: moment().format("YYYY-MM")
    };
  },
  created() {},
  mounted() {
    // 读取本地缓存，判断当天是否已看过使用说明（每天提醒一次）
    const guideReadDate = localStorage.getItem('qua_guide_read');
    const today = moment().format('YYYY-MM-DD');
    if (guideReadDate !== today) {
      this.showUsageGuide = true;
    }

    this.typeFlag = this.$route.query.type;
    if (this.$route.query.yearMonth) {
      this.newDate2 = this.$route.query.yearMonth;
      this.currentDate2 = new Date(this.$route.query.yearMonth);
      this.newDateValue2 = this.$route.query.yearMonth;
    }
    // this.showUserBadge = this.$store.state.userInfo.username == "10004381";
    const ac = localStorage.getItem("quaActive");
    const tabsActive = localStorage.getItem("tabsActive");
    this.active = Number(ac);
    if (tabsActive) {
      this.activeTabs = Number(tabsActive);
    } else {
      this.activeTabs = 1;
    }
    let token = window.sessionStorage.hrToken;
    let hrToken = getToken();
    if (token) {
      this.empno = hrToken;
      //根据type显示不同的点赞卡列表
      if (this.$route.query.type == 1) {
        this.medalCardNewReceived();
      }
      if (this.$route.query.type == 2) {
        this.queryListTwo();
      }
      if (this.$route.query.type == 3) {
        this.queryListThree();
      }
    } else {
      this.$bus.$on("processToken", res => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.empno = res;
          if (this.$route.query.type == 1) {
            this.medalCardNewReceived();
          }
          if (this.$route.query.type == 2) {
            this.queryListTwo();
          }
          if (this.$route.query.type == 3) {
            this.queryListThree();
          }
          // if (this.activeTabs == 1) {
          //   this.init();
          // } else {
          //   this.init1();
          // }
        });
      });
    }
  },
  methods: {
    // 点击我知道了，标记已读
    handleKnowGuide() {
      // 记录当天日期，用于判断当天是否已看过
      localStorage.setItem('qua_guide_read', moment().format('YYYY-MM-DD'))
      this.showUsageGuide = false
    },
    // 返回上一页
    goback() {
      this.$router.go(-1);
    },
    //确认选择时间
    comfirmPickTime(value) {
      this.newDate = moment(value).format("YYYY-MM");
      this.currentDate = value;
      this.newDateValue = value;
      this.queryListTwo();
      this.showPickDate = false;
    },
    //确认选择时间
    comfirmPickTime2(value) {
      this.newDate2 = moment(value).format("YYYY-MM");
      this.currentDate2 = value;
      this.newDateValue2 = value;
      this.queryListThree();
      this.showPickDate2 = false;
    },
    //获取token&用户信息
    getHrToken(username) {
      return new Promise(resolve => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }
          apiLogin.getUserToken({ username: thisname }).then(data => {
            // console.log(data);
            const info = data.data;
            localStorage.setItem("salaryPhone", info.mobileNo);
            localStorage.setItem("salaryInfo", JSON.stringify(info));
            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    // 在苹果手机上唤起键盘
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    //聚焦时显示弹框高度
    onblur2() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select2.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly2(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select2 } = this.$refs;
          const input = select2.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    //改变赠送名字
    changeOption(value) {
      this.loadingSelect = true;
      api
        .quaGetEmployeeInfo({
          name: value
        })
        .then(data => {
          this.options = data.data;
          this.loadingSelect = false;
        });
    },
    //取消赠送
    handelNo() {
      this.showTip = false;
    },
    //确认赠送
    handelOk() {
      const cc = this.valueCC.length > 0 ? this.valueCC.join(",") : "";
      this.disabled = true;
      if (this.value && this.message) {
        api
          .quaSend({
            id: this.id,
            receiver: this.value,
            reason: this.message,
            cc
          })
          .then(() => {
            this.showTip = false;
            this.disabled = false;
            this.pageOne = 1;
            this.$message({
              type: "success", // success error warning
              message: "发送成功",
              duration: 2000
            });
          })
          .catch(err => {
            this.disabled = false;
            this.$message({
              type: "warning", // success error warning
              message: err.message,
              duration: 2000
            });
          });
      } else {
        this.disabled = false;
        this.$message({
          type: "warning", // success error warning
          message: "发送人和留言不能为空",
          duration: 2000
        });
      }
    },
    //跳转勋章&点赞卡详情
    toUrl(item) {
      if (item.cardType == 1) {
        this.$router.push({
          path: "/mobile/medal/quaquakaDetail",
          query: {
            id: item.id,
            value: 2
          }
        });
      }
      if (item.cardType == 3) {
        this.$router.push({
          path: "/mobile/medal/badgeDetail",
          query: {
            id: item.id,
            value: 2
          }
        });
      }
      if (item.cardType == 2) {
        this.$router.push({
          path: "/mobile/medal/newsNotice/medalDetail",
          query: {
            id: item.id,
            value: 2
          }
        });
      }
      if (item.cardType == 4) {
        this.$router.push({
          path: "/mobile/medal/publicWelfare/benefitDetail",
          query: {
            id: item.id,
            value: 2
          }
        });
      }
    },
    //跳转勋章&点赞卡详情
    toUrl1(item) {
      if (item.cardType == 1) {
        this.$router.push({
          path: "/mobile/medal/quaquakaDetail",
          query: {
            id: item.id
          }
        });
      }
      if (item.cardType == 3) {
        this.$router.push({
          path: "/mobile/medal/badgeDetail",
          query: {
            id: item.id
          }
        });
      }
      if (item.cardType == 2) {
        this.$router.push({
          path: "/mobile/medal/newsNotice/medalDetail",
          query: {
            id: item.id
          }
        });
      }
      if (item.cardType == 4) {
        this.$router.push({
          path: "/mobile/medal/publicWelfare/benefitDetail",
          query: {
            id: item.id
          }
        });
      }
    },
    //跳转勋章&点赞卡详情
    toUrlImm(id, status) {
      if (status == "2") {
        this.$router.push({
          path: "/mobile/medal/quaquakaDetail",
          query: {
            id: id
          }
        });
      }
    },
    onClickSong(id) {
      this.$router.push({
        path: "/mobile/medal/quaquaka/send",
        query: {
          id: id
        }
      });
    },
    //赠送 夸夸列表
    medalCardNewReceived() {
      api
        .medalCardLstApi({
          page: 1,
          pageSize: 2000,
          empno: this.empno,
          hrAuthToken: window.sessionStorage.hrToken
        })
        .then(res => {
          if (res.code == 200) {
            this.list = res.data;
          }
        });
    },
    changeSearchValue1() {
      this.queryListTwo();
    },
    //我收到的
    queryListTwo() {
      api
        .medalCardNewReceivedApi({
          recordType: 2,
          empno: this.empno,
          yearMonth: moment(this.newDateValue).format("YYYY-MM"),
          keyWord: this.searchValue
        })
        .then(res => {
          if (res.code == 200) {
            this.listTwo = res.data;
          }
        });
    },
    //我收到的列表
    changeSearchValue2() {
      this.queryListThree();
    },
    //我收到的
    queryListThree() {
      api
        .medalCardNewReceivedApi({
          recordType: 1,
          empno: this.empno,
          yearMonth: moment(this.newDateValue2).format("YYYY-MM"),
          keyWord: this.searchValue2
        })
        .then(res => {
          if (res.code == 200) {
            this.listThree = res.data;
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #app-home {
    width: 100%;
    // background: rgba(244, 245, 248, 1);
    background: #f7f9fa;
    min-height: 100vh;
    overflow: hidden;
    background: url("~@/assets/newMedal/bg2.png");
    background-size: 100% 100%;
  }
}
@media screen and (min-width: 600px) {
  #app-home {
    width: 276px * $zoom;
    // background: rgba(244, 245, 248, 1);
    background: #f7f9fa;
    min-height: 100vh;
    overflow: hidden;
    background: url("~@/assets/newMedal/bg2.png");
    background-size: 100% 100%;
  }
}
.box {
  width: 100%;
  display: flex;
  justify-content: center;
  .usage-guide-dialog {
    width: 88%;
    max-width: 680px;
    border-radius: 24px;
    overflow: hidden;
  }
  .usage-guide {
    background: #fff;
  }
  .usage-guide-title {
    padding: 30px 30px 20px;
    color: #282b32;
    font-size: 36px;
    font-weight: 700;
    text-align: center;
  }
  .usage-guide-content {
    max-height: 58vh;
    padding: 0 34px;
    overflow-y: auto;
    color: #4a4a4a;
    font-size: 27px;
    line-height: 1.7;
    text-align: justify;
    p {
      margin: 0 0 18px;
    }
    strong {
      color: #282b32;
      font-weight: 700;
    }
  }
  .usage-guide-section {
    margin-bottom: 18px;
    p {
      margin: 8px 0 0;
      padding-left: 1em;
    }
  }
  .usage-guide-ending {
    color: #1fa463;
    font-weight: 600;
  }
  .usage-guide-button {
    width: calc(100% - 68px);
    height: 76px;
    margin: 24px 34px 30px;
    border: 0;
    border-radius: 38px;
    background: #1fa463;
    font-size: 30px;
  }
  .tab-con1 {
    .topCon {
      margin-bottom: 10px;
      position: relative;
      img {
        width: 100%;
        height: 148pt;
      }
      .topTit {
        // font-family: PingFang-SC, PingFang-SC;
        font-weight: 800;
        // font-size: 36px;
        font-size: 32px;
        color: #282b32;
        position: absolute;
        top: 7%;
        left: 10%;
      }
      .topTit1 {
        font-size: 32px;
        font-weight: 800;
        color: #6b3321;
        position: absolute;
        top: 7%;
        left: 10%;
      }
      .topDate {
        // font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        position: absolute;
        top: 25%;
        left: 10%;
        background: linear-gradient(90deg, #d8fd71 0%, #87f6f9 100%);
        color: #357d5c;
        border-radius: 20px;
        padding: 10px 20px;
      }
      .topDate1 {
        // font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        position: absolute;
        top: 25%;
        left: 10%;
        background: #feeede;
        border-radius: 8px;
        border: 1px solid #e3c7b6;
        padding: 10px 20px;
        color: #c58b69;
      }
      .num {
        // font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 23px;
        position: absolute;
        top: 5.5%;
        right: 14.4%;
        color: #1bb888;
      }
      .btnCon {
        display: flex;
        justify-content: center;
        position: absolute;
        top: 62%;
        right: 31%;
        ::v-deep {
          .btnOne {
            width: 264px;
            height: 69px;
            border-radius: 30px;
            background: linear-gradient(333deg, #0aad82 0%, #61e69e 100%);
            color: #fff;
            border: 0;
          }
          .btnOne1 {
            width: 264px;
            height: 69px;
            border-radius: 30px;
            background: linear-gradient(333deg, #eec08e 0%, #fbe0c0 100%);
            color: #fff;
            border: 0;
          }
          .btnTwo {
            width: 264px;
            height: 69px;
            border-radius: 30px;
            background: linear-gradient(333deg, #b5d3cb 0%, #92e6b9 100%);
            color: #fff;
            border: 0;
          }
          .btnTwo1 {
            width: 264px;
            height: 69px;
            border-radius: 30px;
            background: linear-gradient(333deg, #d0af8d 0%, #dcc6af 100%);
            color: #fff;
            border: 0;
          }
        }
      }
    }
  }
  .kong_con {
    width: 100%;
    height: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    justify-content: center;
    .kong_img {
      width: 450px;
      height: 450px;
    }
    .kong_title1 {
      margin-top: 30px !important;
    }
    .kong_title {
      color: #999999;
      font-size: 26px;
      margin-top: 10px;
    }
  }
  .dialog {
    // height: 218px * $zoom;
    padding: 30px;
    .dialog-people {
      margin-bottom: 30px;
    }
    .dialog-reason {
      ::v-deep {
        .van-cell {
          background: rgba(244, 244, 244, 1);
          margin-top: 30px;
          height: 280px;
        }
        .van-field__control {
          height: 200px !important;
        }
      }
    }
    ::v-deep {
      .el-input__inner {
        min-height: 22px * $zoom !important;
      }
    }
    .cc {
      ::v-deep {
        .el-select__tags {
          max-width: none !important;
        }
        .el-input__suffix {
          display: none;
        }
      }
    }
    .dialog-btn {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 30px;
      width: 100%;
      button {
        width: 200px;
        height: 80px;
        border-radius: 40px;
        font-size: 28px;
      }
    }
  }
  .receive {
    background: #fff;
    padding: 30px;
    border-radius: 30px;
    height: 165px * $zoom;
    margin-bottom: 30px;
    .receive-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        color: rgba(61, 61, 61, 1);
        font-weight: 600;
        font-size: 42px;
      }
      .receive-dian {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: rgba(255, 122, 97, 1) !important;
      }
    }
    .receive-con {
      div:nth-child(1) {
        font-size: 30px;
        line-height: 46px;
        margin-bottom: 30px;
        height: 90px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      div:nth-child(2) {
        color: rgba(204, 204, 204, 1);
        font-size: 30px;
      }
    }
    .receive-bom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      div {
        font-size: 32px;
        color: rgba(61, 61, 61, 1);
        font-weight: 600;
      }
      .van-icon {
        font-size: 38px;
        color: rgba(204, 204, 204, 1);
      }
    }
  }
  .header {
    display: flex;
    justify-content: center;
    background: #fff;
  }
  .footer {
    width: 410px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    border: 2px solid #4ea27c;
    margin-top: 30px;
    overflow: hidden;
    .footer_btn {
      // width: 210px;
      width: 50%;
      text-align: center;
      font-weight: 400;
      font-size: 29px;
      height: 62px;
      line-height: 62px;
      // border-radius: 5px;
    }
    .activeBtn {
      color: #fff;
      background: #4ea27c;
    }
    .btn {
      background: #ffffff;
      color: #4ea27c;
    }
  }
}
.goback {
  margin: 10px 40px 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
  }
  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }
  span {
    font-size: 34px;
    flex-shrink: 0;
  }
  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    padding: 0 30px 0 10px;
    align-items: center;
    justify-content: space-between;
    ::v-deep .el-input {
      flex: 1;
      height: 100%;
      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }
    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
.pick {
  width: 92%;
  margin: auto;
  height: 70px;
  border-radius: 80px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  margin-bottom: 15px;
  .newDate {
    flex: 1;
  }
  div {
    color: #969b9e;
    font-size: 30px;
  }
  i {
    color: #969b9e;
  }
}
.message {
  background: #1fbe8a;
  border-radius: 30px;
  padding: 30px;
  width: 92%;
  margin: auto;
  color: #fff;
  margin-bottom: 30px;
  .t1 {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 15px;
  }
  .c1 {
    font-size: 24px;
    line-height: 34px;
    text-indent: 2em;
  }
}
::v-deep {
  .van-tabs__wrap {
    height: 0 !important;
  }
}
::v-deep(.el-divider--horizontal) {
  margin: 30px 0;
}
::v-deep(.van-tabs) {
  // height: calc(100vh - 98px);
  // height: calc(100vh);
  display: flex;
  flex-direction: column;
}
::v-deep(.van-tabs__wrap) {
  //   width: 300px;
  height: 105px;
  position: sticky;
  top: 0;
  left: 0;
  background: #fff;
}
::v-deep(.van-tab) {
  font-size: 29px;
  // font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
::v-deep(.van-tab--active) {
  font-size: 29px;
  // font-family: PingFang-SC-Heavy, PingFang-SC;
  font-weight: 800;
  color: #282b32;
}
::v-deep(.van-tabs__line) {
  border-radius: 0 !important;
}
::v-deep(.van-tabs__content) {
  flex: 1;
  padding: 30px 20px 0px;
  overflow: auto;
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
  &::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }
}
::v-deep(.van-list) {
  .last {
    div:last-child {
      margin-bottom: 0 !important;
    }
  }
}
</style>
